import { EmptyState } from '@teach/ui'
import { useMessages } from '@/i18n'
import { messages } from './messages'

// По центру свободной области вкладки. Высота — меньшее из «экран минус шапка
// страницы» и области контента окна настроек (600 − отступы 64): иначе в окне
// заглушка вылезала за область и стояла ниже центра.
export const CertificatesSection = () => {
  const m = useMessages(messages)
  return (
    <div className="flex min-h-[min(calc(100dvh-22rem),536px)] items-center justify-center">
      <EmptyState
        size="lg"
        className="py-0"
        title={m.certificatesTitle}
        description={m.certificatesDescription}
      />
    </div>
  )
}
